import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { ICoreZonesInitialState } from "./types";

export const setDisplayZones: CaseReducer<ICoreZonesInitialState, PayloadAction<boolean>> = (state, action) => {
  state.displayZones = action.payload;
};

export default { setDisplayZones };
